import { render } from "./MapComponentNotification.vue?vue&type=template&id=5133d626&scoped=true"
import script from "./MapComponentNotification.vue?vue&type=script&lang=js"
export * from "./MapComponentNotification.vue?vue&type=script&lang=js"

import "./MapComponentNotification.vue?vue&type=style&index=0&id=5133d626&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mapalytics-frontend/mapalytics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5133d626"]])

export default __exports__